import { ScreenReaderContent } from "@instructure/ui";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { SubjectService } from "../../services/SubjectService";
import { UserDetailContext } from "../../utils/Context";
import { Selector, SINGLE } from "../Selectors/Selector";

export const ChartSubjectSelect = ({
  selectHandler,
  clear,
  defaultSubject,
  size,
  hierarchySubjects,
  placeholder,
  planSubjects,
}) => {
  const { t } = useTranslation();
  const userDetails = useContext(UserDetailContext);
  const [academicSubjectOptions, setAcademicSubjectOptions] = useState(null);
  const [loading, setLoading] = useState(false);

  // Note: option ids are the titles of the academic subjects (used for getDashboard call)
  useEffect(() => {
    if (userDetails.role && planSubjects) {
      setLoading(true);
      SubjectService.getSubjects().then((academicSubjects) => {
        const selectOptions = [];
        const filtered_subs = academicSubjects.filter(
          (subject) => !planSubjects || planSubjects.includes(subject.id)
        );
        if (filtered_subs) {
          filtered_subs.forEach((s) => {
            if (!userDetails.isAC()) {
              if (
                userDetails.ac_subjects.includes(s.title) &&
                (!hierarchySubjects ||
                  hierarchySubjects.length === 0 ||
                  hierarchySubjects.includes(s.id))
              ) {
                if (s.title) {
                  // temp to exclude the null string title acsub
                  if (s.title !== "" && s.title !== " ") {
                    selectOptions.push({ id: s.title, label: s.name });
                  }
                }
              }
            } else {
              if (
                s.title &&
                (!hierarchySubjects ||
                  hierarchySubjects.length === 0 ||
                  hierarchySubjects.includes(s.id))
              ) {
                // temp to exclude the null string title acsub
                if (s.title !== "" && s.title !== " ") {
                  selectOptions.push({ id: s.title, label: s.name });
                }
              }
            }
          });
        }
        setAcademicSubjectOptions(selectOptions);
        setLoading(false);
      });
    }
  }, [userDetails, hierarchySubjects, planSubjects]);

  return academicSubjectOptions ? (
    <Selector
      type={SINGLE}
      id="academic-subject-filter"
      label={
        <ScreenReaderContent>
          {t("curriculumMap.academicSubjectAssistive")}
        </ScreenReaderContent>
      }
      options={academicSubjectOptions}
      selectHandler={selectHandler}
      selectedItemId={!loading && defaultSubject ? defaultSubject : ""}
      size={size || "medium"}
      clear={clear}
      placeholder={loading ? t("global.loading") + "..." : placeholder}
      interaction={!loading}
    />
  ) : (
    <Skeleton
      height={size === "small" ? 26 : 68}
      style={{ marginTop: "0.75rem" }}
    />
  );
};
